import React from 'react';
import { FormControl, FormHelperText, Drawer, InputLabel, Select, MenuItem } from '@mui/material';
import { ExpandMoreRounded } from '@mui/icons-material';
import DropdownItem from './DropdownItem';
import { Puller } from '../TAGNavigation/TAGPhoneDrawer';
import TAGTypography from '../TAGTypography/TAGTypography';

var TAGSelectDropdown = function TAGSelectDropdown(_ref) {
  var clearMobileOptions = _ref.clearMobileOptions,
      clearOptionText = _ref.clearOptionText,
      closeMobile = _ref.closeMobile,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      drawerOpen = _ref.drawerOpen,
      dropdownArrowBlue = _ref.dropdownArrowBlue,
      dropdownOpen = _ref.dropdownOpen,
      fieldDisabled = _ref.fieldDisabled,
      fieldError = _ref.fieldError,
      fieldHelperText = _ref.fieldHelperText,
      formLabel = _ref.formLabel,
      handleChange = _ref.handleChange,
      handleDrawer = _ref.handleDrawer,
      handleMobileSelect = _ref.handleMobileSelect,
      items = _ref.items,
      selected = _ref.selected,
      sx = _ref.sx;
  var ddArrowConditional = dropdownArrowBlue ? 'secondary' : color; // const labelConditional = fieldError ? ASPENDENTAL_COLOR.error[700] : ASPENDENTAL_COLOR.text.primary
  // const errorConditionalFocused = fieldError ? ASPENDENTAL_COLOR.error[700] : ASPENDENTAL_COLOR.secondary[500]
  // const errorConditionalNeutral = fieldError ? ASPENDENTAL_COLOR.error[700] : ASPENDENTAL_COLOR.neutrals[700]

  var transformedColor = color.includes('.') ? color : "".concat(color, ".main");
  return React.createElement(FormControl, {
    fullWidth: true,
    error: fieldError,
    // color={color}
    sx: [{
      '& label.Mui-focused': {
        color: fieldError ? 'error.dark' : transformedColor
      },
      // '& label': {
      //   color: fieldDisabled ? ASPENDENTAL_COLOR.text.disabled : labelConditional,
      // },
      // '&.MuiInput-formControl': { borderColor: 'red' },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: fieldError ? 'error.dark' : transformedColor
        }
      },
      '& .Mui-error': {
        color: 'error.dark',
        '& .Mui-focused fieldset': {
          borderColor: 'error.dark'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'error.dark'
        }
      }
    }, sx]
  }, React.createElement(InputLabel, null, formLabel), React.createElement(Select, {
    fullWidth: true,
    variant: "outlined",
    label: formLabel,
    value: selected,
    disabled: fieldDisabled,
    onChange: handleChange,
    IconComponent: ExpandMoreRounded,
    sx: {
      '.MuiListItemText-root': {
        my: '0px',
        height: '23px'
      },
      '.MuiSelect-iconOutlined': {
        color: fieldError ? 'error.dark' : ddArrowConditional
      }
    },
    onOpen: handleDrawer,
    open: drawerOpen ? false : dropdownOpen
  }, clearOptionText && React.createElement(MenuItem, null, React.createElement("em", null, clearOptionText)), items.map(function (item) {
    return React.createElement(MenuItem, {
      key: item.itemText,
      value: item.itemText,
      sx: {
        borderTop: item.divider ? '1px solid' : 'none',
        borderColor: item.divider ? 'neutrals.disabled' : 'none'
      }
    }, React.createElement(DropdownItem, {
      itemText: item.itemText,
      iconName: item.iconName,
      iconBoolean: item.iconBoolean
    }));
  })), React.createElement(Drawer, {
    open: drawerOpen,
    ModalProps: {
      onBackdropClick: closeMobile
    },
    anchor: "bottom",
    sx: {
      display: {
        xs: 'block',
        sm: 'none'
      },
      '.MuiDrawer-paperAnchorBottom': {
        borderRadius: '30px 30px 0 0',
        paddingTop: 4
      }
    },
    PaperProps: {
      sx: {
        maxHeight: '80%'
      }
    }
  }, React.createElement(Puller, null), clearOptionText && React.createElement(MenuItem, {
    value: '',
    onClick: function onClick() {
      return clearMobileOptions();
    }
  }, React.createElement("em", null, clearOptionText)), items.map(function (item) {
    return React.createElement(MenuItem, {
      key: item.itemText,
      value: item.itemText,
      onClick: function onClick(event) {
        return handleMobileSelect(event);
      },
      sx: {
        borderTop: item.divider ? '1px solid' : 'none',
        borderColor: item.divider ? 'neutrals.disabled' : 'none'
      }
    }, React.createElement(DropdownItem, {
      itemText: item.itemText,
      iconName: item.iconName,
      iconBoolean: item.iconBoolean
    }));
  })), fieldHelperText && React.createElement(FormHelperText, {
    error: fieldError,
    sx: {
      marginLeft: 0,
      '&.Mui-error': {
        color: 'error.dark'
      }
    }
  }, React.createElement(TAGTypography, {
    variant: "lowestLevel"
  }, fieldHelperText)));
};

export default TAGSelectDropdown;